import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable()
export class VerticalsService {
    private verticals = [];
    private taxonomyVerticals = [];
    private error = '';

    constructor(private api: ApiService) {
        const taxObj = JSON.parse(JSON.stringify( this.api.getProp('taxonomies') ));
        const taxKeys = Object.keys(taxObj);
        const taxonomies = [];
        for(var i = 0; i < taxKeys.length; i++) {
            const slug = taxKeys[i];
            const tax = taxObj[slug];
            taxonomies.push(tax);
        }
        const taxonomyVerticals = taxonomies.find((tax) => tax.name.toLowerCase() === 'vertical')?.options;

        let verticals = this.api.getProp('verticals');

        let sites = this.api.getProp('sites');

        // create missing sites
        sites.forEach((site, index) => {
            if (
                verticals.some(
                    (vertical) => vertical.site[0].blog_id == site.blog_id
                )
            )
                return;
            verticals.push({
                site: [site],
                states: [],
            });
        });

        verticals.forEach((vertical) => {
            const verticalStates = taxonomyVerticals.map((vertical) => {
                return {
                    term_id: vertical.term_id,
                    allowed: false,
                };
            });

            verticalStates.forEach((state) => {
                const termId = state.term_id;

                const found = vertical.states.findIndex((state) => {
                    return state.term_id == termId;
                });

                if (found > -1) {
                    state.allowed = vertical.states[found].allowed;
                }
            });

            vertical.states = verticalStates;

            // needed to fix column offset
            vertical.states.unshift({
                term_id: -1,
                allowed: false,
            });
        });

        this.verticals = verticals;
        this.taxonomyVerticals = taxonomyVerticals;
    }

    public getVerticals() {
        return this.verticals;
    }

    public getTaxonomyVerticals() {
        return this.taxonomyVerticals;
    }

    public updateVerticals(verticals) {
        return this.api
            .doAction('post', 'verticals', {
                action: 'update',
                data: verticals,
            })
            .subscribe(
                (data) => {
                    if (data.verticals) {
                        this.verticals = data.verticals;
                    }
                },
                (err) => {
                    this.error = err.error.message;
                    throw err;
                }
            );
    }

    public getError() {
        return this.error;
    }

    public resetError() {
        this.error = '';
    }
}